import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿Qué es exactamente PromptAdsPro?',
  answer: 'Es un software de ingeniería publicitaria que analiza tu producto, selecciona el ángulo psicológico adecuado y genera creativos listos para testear en Meta Ads. No es un generador de texto genérico — es un sistema estratégico con 24 ángulos probados.'
}, {
  question: '¿Necesito experiencia con IA o copywriting?',
  answer: 'No. PromptAdsPro está diseñado para que cualquier media buyer o infoproductor pueda usarlo sin curva de aprendizaje. En 30 minutos ya vas a estar generando creativos estratégicos.'
}, {
  question: '¿Funciona para mi nicho?',
  answer: 'Sí. Los 24 ángulos psicológicos son universales: dolor, deseo, FOMO, identidad, estatus, etc. Funcionan para infoproductos, e-commerce, servicios, SaaS y cualquier oferta que necesite anuncios persuasivos.'
}, {
  question: '¿Qué formatos de creativos puedo generar?',
  answer: 'Carruseles, guiones de Reels, VSLs de alto impacto, textos para imagen estática, newsletters y más. Todo optimizado para Meta Ads y listo para copiar y pegar.'
}, {
  question: '¿Cómo recibo el producto?',
  answer: 'Inmediatamente después del pago recibís acceso al software y todos los bonos por email. Es 100% digital — sin esperas.'
}, {
  question: '¿Qué pasa si no me sirve?',
  answer: 'Tenés 7 días de garantía total. Si sentís que no es para vos, te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };
  return <section className="bg-black py-16 px-4 border-t border-matrix-green/10" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <div className="text-center mb-10" data-id="element-67">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center gap-2 bg-matrix-green/10 border border-matrix-green/30 px-4 py-2 rounded-full mb-6" data-id="element-68">
            <HelpCircle className="w-5 h-5 text-matrix-green" data-id="element-69" />
            <span className="text-matrix-green font-mono text-sm font-bold uppercase tracking-wider" data-id="element-70">
              FAQ
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl font-bold text-white" data-id="element-71">
            Preguntas{' '}
            <span className="text-matrix-green text-glow-green" data-id="element-72">
              Frecuentes
            </span>
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-3" data-id="element-73">
          {faqs.map((faq, idx) => <div key={idx} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === idx ? 'border-matrix-green/40 bg-premium-mid/80' : 'border-matrix-green/15 bg-premium-mid/30'}`} data-id="element-74">
              <button onClick={() => toggle(idx)} className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer group" data-id="element-75">
                <span className="font-heading font-bold text-base md:text-lg text-white group-hover:text-matrix-green transition-colors" data-id="element-76">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-matrix-green flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-77" />
              </button>

              <AnimatePresence data-id="element-78">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-79">
                    <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-80">
                      <div className="w-full h-px bg-matrix-green/15 mb-4" data-id="element-81" />
                      <p className="font-body text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-82">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </motion.div>
      </div>
    </section>;
}